ApplicationSerializer = require './application'

App.AdvertSerializer = ApplicationSerializer.extend DS.EmbeddedRecordsMixin,
  attrs:
    restaurants: serialize: 'ids'

  serialize: (record, options) ->
    json = @_super(record, options)

    scheduledAt = record.get('scheduled_at')
    orgTimezone = record.get('organization.timezone')

    if scheduledAt? and orgTimezone?
      # Преобразуем scheduled_at с таймзоной организации
      formatted = moment.tz(scheduledAt, orgTimezone).format()  # ISO string with offset
      json['scheduled_at'] = formatted

    json